// A request with one of most things worth showing in it: a method, two headers, a body, a flag and a bundled pair.
// The host is httpbin.org because it answers a preflight and echoes the request back, so Send shows what was built
// rather than the CORS refusal a made-up address would answer with.
export const SAMPLE_COMMAND = [
  "curl https://httpbin.org/post \\",
  "  -X POST \\",
  "  -H 'Content-Type: application/json' \\",
  "  -H 'Authorization: Bearer s3cr3t' \\",
  "  -d '{\"name\":\"widget\",\"quantity\":3}' \\",
  "  --compressed \\",
  "  -sS",
].join("\n");
